/** Opens today's Visit beside the approval; it never replaces the saved snapshot on screen. */
import { DOCUMENT } from '@angular/common';
import { Injector } from '@angular/core';
import { VisitApprovalVisitRow } from '@jms/model';

export function viewCurrentApprovalVisit(injector: Injector, row: VisitApprovalVisitRow): void {

  // Approving stores the row, so the occurrence id is the Visit's id.
  injector.get(DOCUMENT).defaultView?.open(`/crm/visits/${encodeURIComponent(row.occurrenceId)}`, '_blank', 'noopener');
}
